import { useNavigate } from 'react-router-dom';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { ArrowLeft, Clock } from 'lucide-react';

/**
 * Lesson header with back navigation and topic info
 */
export const LessonHeader = ({ topic }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    const phaseId = topic?.phase_id;
    if (phaseId) {
      const phaseNum = parseInt(phaseId.replace('phase_', ''), 10);
      if (phaseNum >= 1 && phaseNum <= 4) {
        navigate(`/rpat/phase/${phaseId}`);
      } else if (phaseNum === 5) {
        navigate('/rpat/certification/job-mastery');
      } else if (phaseNum === 6) {
        navigate('/rpat/certification/sourcing-labs');
      } else if (phaseNum === 7) {
        navigate('/rpat/certification/roleplay');
      } else if (phaseNum === 8) {
        navigate('/rpat/certification/final');
      } else {
        navigate('/rpat');
      }
    } else {
      navigate('/rpat');
    }
  };

  return (
    <div className="flex items-center gap-4">
      <Button variant="ghost" size="icon" onClick={handleBack} data-testid="lesson-back-btn">
        <ArrowLeft className="h-5 w-5" />
      </Button>
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1">
          <Badge variant="outline">{topic?.code}</Badge>
          <Badge variant="secondary" className="gap-1">
            <Clock className="h-3 w-3" />
            {topic?.duration_minutes} min
          </Badge>
        </div>
        <h1 className="text-2xl font-bold">{topic?.title}</h1>
      </div>
    </div>
  );
};

export default LessonHeader;
